import './AnalyticsGuide.css';

/**
 * EmptyStateGuide — replaces a generic "no data" state with a contextual message and suggested actions.
 *
 * Props:
 *   condition  (bool)    – render only when true (no data)
 *   icon       (string)  – emoji/icon (optional)
 *   title      (string)  – headline for the empty state
 *   message    (string)  – explanation of why the state is empty
 *   actions    (Array<{ label: string, href?: string, onClick?: fn }>)  – suggested next steps
 */
export default function EmptyStateGuide({ condition, icon = '📭', title, message, actions = [] }) {
    if (!condition) return null;

    return (
        <div className="empty-state-guide" role="status">
            <div className="empty-state-icon">{icon}</div>
            {title && <div className="empty-state-title">{title}</div>}
            {message && <div className="empty-state-message">{message}</div>}
            {actions.length > 0 && (
                <div className="empty-state-actions">
                    {actions.map((action, i) =>
                        action.href ? (
                            <a key={i} href={action.href} className="empty-state-btn">
                                {action.label}
                            </a>
                        ) : (
                            <button key={i} className="empty-state-btn" onClick={action.onClick}>
                                {action.label}
                            </button>
                        )
                    )}
                </div>
            )}
        </div>
    );
}
